import React, { useEffect, useState } from "react";
import About from "../../../components/unauth/home/About";
import Contact from "../../../components/unauth/home/Contact";
import Events from "../../../components/unauth/home/Events";
import Feedback from "../../../components/unauth/home/Feedback";
import Gallery from "../../../components/unauth/home/Gallery";
import Hero from "../../../components/unauth/home/Hero";
import { IMAGE } from "../../../api/Image";
import { GALLERY } from "../../../api/Gallery";
import { EVENT } from "../../../api/Event";
import { LINKS } from "../../../api/Links";
import { SERVICE } from "../../../api/Service";
import Loading from "../../../components/unauth/loading/Loading";
import ChatBot from "../../../components/unauth/chatbot/ChatBot";
export default function HomeScreen() {
  const [image, setImage] = useState(null);
  const [gallery, setGallery] = useState(null);
  const [event, setEvent] = useState([]);
  const [links, setLinks] = useState(null);
  const [service, setService] = useState([]);

  const getImageList = async () => {
    try {
      const res = await IMAGE.GET_ALL();
      if (res.status !== 200) {
        throw new Error("Failed to fetch cake information");
      }
      setImage(res.data[0]);
    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };
  const getGalleryList = async () => {
    try {
      const res = await GALLERY.GET_ALL();
      if (res.status !== 200) {
        throw new Error("Failed to fetch cake information");
      }
      setGallery(res.data[0]);
    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };
  const getEventList = async () => {
    try {
      const res = await EVENT.GET_ALL();
      if (res.status !== 200) {
        throw new Error("Failed to fetch cake information");
      }
      setEvent(res.data);
    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };
  const getLinksList = async () => {
    try {
      const res = await LINKS.GET_ALL();
      if (res.status !== 200) {
        throw new Error("Failed to fetch information");
      }
      setLinks(res.data[0]);
    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };

  const getServiceList = async () => {
    try {
      const res = await SERVICE.GET_ALL();
      if (res.status !== 200) {
        throw new Error("Failed to fetch information");
      }
      setService(res.data[0]);
    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };

  useEffect(() => {
    getImageList();
    getGalleryList();
    getEventList();
    getLinksList();
    getServiceList();
  }, []);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="relative">
      {image !== null &&
      image !== undefined &&
      event !== null &&
      event !== undefined &&
      gallery !== null &&
      gallery !== undefined &&
      service !== null &&
      service !== undefined &&
      links !== null &&
      links !== undefined ? (
        <>
          <div id="hero">
            <Hero image={image.heroImg} />
          </div>
          <div id="event">
            <Events event={event} />
          </div>
          <Gallery gallery={gallery} />
          <div id="services">
            <About service={service} />
          </div>
          <div id="feedback">
            <Feedback image={image.contactImg} />
          </div>
          <div id="contact">
            <Contact links={links} />
          </div>
          <ChatBot setIsOpen={setIsOpen} isOpen={isOpen} />
          <div className="z-9 fixed bottom-10 right-10 flex flex-col gap-5">
            <button
              className="bg-primary drop-shadow-xl rounded-full p-2 h-15 w-15 border-[1px] border-gray text-3xl"
              onClick={() => setIsOpen(!isOpen)}
            >
              {/* <img
                src="https://cdn-icons-png.flaticon.com/512/12383/12383841.png"
                alt="arrow"
                className="w-10 rounded-full object-cover"
              /> */}
              💬
            </button>
            {/* <button
              className="bg-event rounded-full p-2 h-10 w-10"
              onClick={() => {
                setTimeout(() => {
                  const session = document.querySelector("#hero");
                  if (session) {
                    session.scrollIntoView({ behavior: "smooth" });
                  }
                }, 100); // slight delay so menu closes first
              }}
            >
              <img
                src="https://www.freeiconspng.com/thumbs/white-arrow-png/curved-white-arrow-png-0.png"
                alt="arrow"
                className="w-10  object-contain"
              />
            </button> */}
          </div>
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
}
